import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Button,
  Divider,
  Stack,
} from "@mui/material"
import { NavLink } from "react-router-dom"
import { menuItems } from "../../constants/menuItems"

export default function HeaderMobileDrawer({
  drawerOpen,
  onClose,
  isLoggedIn,
  userData,
  handleLogout,
  goToDashboardTab,
}) {
  const handleAction = (action) => {
    onClose()
    if (typeof action === "function") action()
  }

  const drawerButtonStyle = {
    fontSize: "16px",
    fontWeight: 600,
    color: "text.menu.heading",
    mb: 2,
  }

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: "100vw",
            borderRadius: 0,
            height: `calc(100vh - 50px)`,
            marginTop: `60px`,
            maxWidth: "100%",
          },
        },
        backdrop: {
          sx: {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      <Box sx={{ width: "100%", pt: 2 }}>
        <Typography
          sx={{
            ml: 2,
            color: "text.heading",
            fontSize: "20px",
            fontWeight: 800,
          }}
        >
          My Account
        </Typography>

        <List>
          {!isLoggedIn && (
            <ListItem sx={{ mb: 2 }}>
              <Button
                variant="contained"
                component={NavLink}
                to="/login"
                sx={{
                  color: "white",
                  backgroundColor: "#FC3468",
                  width: "100%",
                  "&:hover": { backgroundColor: "#ff0044ff" },
                }}
                onClick={onClose}
              >
                Sign in
              </Button>
            </ListItem>
          )}

          {isLoggedIn && (
            <>
              <ListItem>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.3,
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: 600,
                      color: "text.menu.heading",
                      fontSize: "14px",
                    }}
                  >
                    {userData?.first_name} {userData?.last_name}
                  </Box>
                  <Box
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "text.menu.subtext",
                    }}
                  >
                    {userData?.email}
                  </Box>
                </Box>
              </ListItem>
              <Divider sx={{ my: 2 }} />
              <Stack
                direction="column"
                sx={{ mt: 1, ml: "10px", alignItems: "flex-start" }}
              >
                <Button
                  size="small"
                  sx={drawerButtonStyle}
                  onClick={() => handleAction(() => goToDashboardTab("main"))}
                >
                  My Account
                </Button>
                <Button
                  size="small"
                  sx={drawerButtonStyle}
                  onClick={() =>
                    handleAction(() => goToDashboardTab("myBookings"))
                  }
                >
                  Bookings
                </Button>
              </Stack>
              <Divider sx={{ my: 2 }} />
            </>
          )}

          {menuItems.map((item) => (
            <ListItemButton
              key={item.label}
              component={NavLink}
              to={item.href}
              onClick={onClose}
            >
              <ListItemText
                primary={item.label}
                slotProps={{
                  primary: {
                    sx: {
                      fontSize: "16px",
                      fontWeight: 600,
                      color: "text.menu.heading",
                      mb: "12px",
                    },
                  },
                }}
              />
            </ListItemButton>
          ))}

          {isLoggedIn && (
            <>
              <Divider sx={{ my: 2 }} />
              <Button
                sx={{
                  ml: "10px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "text.menu.heading",
                }}
                size="small"
                onClick={handleLogout}
              >
                Sign Out
              </Button>
            </>
          )}
        </List>
      </Box>
    </Drawer>
  )
}
